<script lang="ts">
  import type { HtmlContent } from "$lib/elev8Api/contentTypes";

  interface Props {
    content: HtmlContent;
  }
  const { content }: Props = $props(); // content prop to match factory interface but unused.
  //   const { html } = content.content_data;
</script>

<!-- {@html html} -->

<div class="html-content">HTML CONTENT COMPONENT PLACEHOLDER</div>

<style>
  .html-content {
    padding: 5%;
    color: #000;
    background-color: #fff;
    width: 90%;
    height: auto;
  }
</style>
